module.exports = __webpack_public_path__ + "img/layout-default.52995f6b.png";